const RELOAD_KEY = 'chunk-error-reload';
const RELOAD_TIMEOUT_MS = 30000;

export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.client) return;

  const stabilityTimer = setTimeout(() => {
    if (sessionStorage.getItem(RELOAD_KEY)) {
      console.info('[Stability] App stability. Cleaning security key.');
      sessionStorage.removeItem(RELOAD_KEY);
    }
  }, 10000);

  const handleReload = (source: string) => {
    const lastReload = sessionStorage.getItem(RELOAD_KEY);
    const now = Date.now();

    if (lastReload && now - Number(lastReload) < RELOAD_TIMEOUT_MS) {
      console.error(`[${source}] Chunk error detected, skipping reload to avoid infinite loop.`);
      return;
    }

    sessionStorage.setItem(RELOAD_KEY, String(now));
    clearTimeout(stabilityTimer);

    reloadNuxtApp({
      path: window.location.pathname,
      persistState: false
    });
  };

  nuxtApp.hook('app:chunkError', () => {
    handleReload('NuxtHook');
  });

  nuxtApp.hook('vue:error', (error) => {
    const msg = error instanceof Error ? error.message : String(error);
    const isChunkError =
      msg.includes('Failed to fetch dynamically imported module') ||
      msg.includes('Loading chunk');

    if (isChunkError) {
      handleReload('VueError');
    }
  });
});
